import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  borderRadius8,
  boxShadowBlack12,
} from 'approot/shared/styles/borders.style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { fontSize18 } from 'approot/shared/styles/typography.style';
import { spacing24 } from 'approot/shared/styles/spacing.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const ComponentLoadingText = styled.div`
  ${boxShadowBlack12}
  background-color: ${grey1};
  border-radius: ${rem(64)};
  border: 1px solid ${grey1};
  font-size: ${rem(fontSize18)};
  height: ${rem(50)};
  display: inline-flex;
  align-items: center;
  padding: 0 ${rem(spacing24)};
`;

type ComponentLoadingProps = {
  $noBackground?: boolean;
};
export const ComponentLoading = styled.div<ComponentLoadingProps>`
  ${flexCentreAlignCss}
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: ${rem(borderRadius8)};
  border: none;
  padding: 0;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
`;
